import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

import OutputText from '@ey/canvascoreservices/OutputText';

import User from '../../../../../../CoreWrappers/User';
import HrAlt from '../../../../../../Common/Hr/HrAlt';
import StyledRow from './StyledRow';
import StyledUserList from './StyledUserList';

const UserList = ({entityList, renderControls}) => {
	if (entityList === null) return null;

	const renderContact = (index, user, entityId, props) => (
		<Fragment key={`${index}${user.userId}`}>
			<StyledRow>
				<User {...props} />
				{renderControls && <>{renderControls(user, entityId)}</>}
			</StyledRow>
			<HrAlt />
		</Fragment>
	);

	const renderEntity = (entity, index) => {
		const {entityId, entityName, contacts} = entity;
		if (contacts?.length === 0) return null;
		return (
			<Fragment key={`${index}${entityId}`}>
				<OutputText>{entityName}</OutputText>
				{contacts.map((contact, index) => {
					const {name: firstName, lastName, emailAddress, isInternal} = contact;
					const props = {firstName, lastName, email: emailAddress, isInternal, showType: true, showInfo: false};
					return renderContact(index, contact, entityId, props);
				})}
			</Fragment>
		);
	};

	return <StyledUserList>{entityList.map(renderEntity)}</StyledUserList>;
};

UserList.propTypes = {
	entityList: PropTypes.arrayOf(PropTypes.shape({})),
	renderControls: PropTypes.func
};

UserList.defaultProps = {
	entityList: null,
	renderControls: null
};

export default UserList;
